import { PropsWithChildren } from "react"
import { makeStyles } from "tss-react/mui"
import { Stack, Typography } from "@mui/material"

const useStyles = makeStyles()((theme) => ({
    box: {
        border: `1px solid ${theme.palette.tailwind.slate[200]}`,
        borderRadius: ".75rem",
        padding: "1.5rem 1rem",
        color: theme.palette.text.primary,
        textAlign: "left",
    },
    title: {
        color: theme.palette.tailwind.slate[950],
    },
}))
type OrderSummaryItemProps = Readonly<
    PropsWithChildren<{
        title: string
    }>
>

export function OrderSummaryItem({ title, children }: OrderSummaryItemProps) {
    const { classes } = useStyles()

    return (
        <Stack gap="1rem">
            <Typography variant="subtitle1" className={classes.title}>
                {title}
            </Typography>
            <Stack className={classes.box}>{children}</Stack>
        </Stack>
    )
}
